module.exports = require("mdi-material-ui/MicrophoneOff");